import L from 'leaflet';

/**
 * Adds the default basemap to the map. Online only.
 *
 * @param {object} leafletMap - The leaflet map object.
 */
const addOnlineBaseMap = leafletMap => {
  const esriImagery = {
    url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    attribution:
      'Tiles &copy; Esri &mdash; Source: DigitalGlobe, GeoEye, i-cubed, USDA, USGS, AEX, Getmapping, Aerogrid, IGN, IGP, swisstopo, and the GIS User Community'
  };

  const esriImageryLabels = {
    url:
      'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}',
    attribution:
      'Tiles &copy; Esri &mdash; Source: DigitalGlobe, GeoEye, i-cubed, USDA, USGS, AEX, Getmapping, Aerogrid, IGN, IGP, swisstopo, and the GIS User Community'
  };

  // FIXME: this maps add too much clutter and is ugly. It will remain here until final deprecation
  // const esriImageryTransportation = {
  //   url:
  //     'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}',
  //   attribution:
  //     'Tiles &copy; Esri &mdash; Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'
  // };
  const maxZoom = 22;
  const minZoom = 0;
  L.tileLayer(esriImagery.url, { attribution: esriImagery.attribution, maxZoom, minZoom }).addTo(
    leafletMap
  );

  L.tileLayer(esriImageryLabels.url).addTo(leafletMap);

  // FIXME: idem previous fixme
  // L.tileLayer(esriImageryTransportation.url, {
  //   attribution: esriImageryTransportation.attribution
  // }).addTo(leafletMap);
};

export default addOnlineBaseMap;
